import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { AlertController, Platform } from '@ionic/angular';
import OneSignal from 'onesignal-cordova-plugin';
import { ModelLocatorService } from '../services/config/model-locator.service';

/**
 * Serviço de push via OneSignal
 * @author Starley Cazorla
 */

@Injectable()
export class OneSignalProvider {

    isAlreadyShowAlert = false;
    constructor(public platform: Platform,
        private modelLocator: ModelLocatorService,
        private router: Router,
        private alertController: AlertController
    ) {
    }

    /**
    * Configura oneSignal
    */
    async setupPushOneSignal() {
        if (Capacitor.getPlatform() !== 'web') {
            console.log('--- One Signal ---');

            // I recommend to put these into your environment.ts
            OneSignal.initialize('3eaaff42-6389-4401-a139-2bc512a8fc44');

            OneSignal.Notifications.addEventListener('click', async (event) => {
                console.log("🚀 ~ OneSignalProvider ~ OneSignal.Notifications.addEventListener ~ event:", event);
                let notification = event.notification;
                console.log("Notification Clicked : " + JSON.stringify(notification));
                await this.extractAdditionalData(notification.additionalData);
            });

            OneSignal.Notifications.addEventListener("foregroundWillDisplay", async (event: any) => {
                const notification = event.notification;
                console.log("Notification Clicked : " + JSON.stringify(notification));
                await this.extractAdditionalData(notification.additionalData);
            });

            OneSignal.Notifications.requestPermission(true).then((success: Boolean) => {
                console.log("Notification permission granted " + success);
            })
        }
    }

    /**
     * Sends tags one signal
     * @author Starley Cazorla
     */
    async sendTagsOneSignal() {
        try {
            if (this.platform.is('cordova')) {
                const oneSignalIdentification = {
                    cpf: this.modelLocator.dadosLogin.cpf,
                    idperfil: this.modelLocator.dadosLogin.idperfil,
                    ltm_id: this.modelLocator.dadosLogin.ltm_id,
                    perfil: this.modelLocator.dadosLogin.perfil,
                    idowner: this.modelLocator.dadosLogin.idowner,
                    documentacao: this.modelLocator.dadosLogin.documentacao,
                    classificacao: this.modelLocator.dadosLogin.classificacao,
                    tags: JSON.stringify(this.modelLocator.dadosLogin.tags),
                    nome: this.modelLocator.dadosLogin.nome.split(' ')[0]
                };
                OneSignal.User.addTags(oneSignalIdentification);

                OneSignal.login(this.modelLocator.dadosLogin.cpf.replace(/\D+/g, ''));
                if (this.modelLocator.dadosLogin.email) {
                    OneSignal.User.addEmail(this.modelLocator.dadosLogin.email);
                }
                if (this.modelLocator.dadosLogin.celular) {
                    OneSignal.User.addSms('+55' + this.modelLocator.dadosLogin.celular);
                }
            }
        } catch (error) {
            console.log("🚀 ~ file: login-service.service.ts:70 ~ LoginService ~ sendTagsOneSignal ~ error:", error)
        }
    }

    async extractAdditionalData(additionalData: any) {

        console.log('Additional Data:', JSON.stringify(additionalData));
        // Exemplo de rotina baseada nos dados adicionais
        if (additionalData && additionalData.page && additionalData.title && !this.isAlreadyShowAlert) {
            this.isAlreadyShowAlert = true;
            const title = additionalData.title || 'Notificação recebida'; // Mensagem padrão
            const mensagem = additionalData.message;
            const rotaDestino = additionalData.page;
            console.log('Executando rotina para tarefa:', additionalData.page);
            this.redirectNotification(title, mensagem, rotaDestino);
        } else if (additionalData && additionalData.page && !this.isAlreadyShowAlert) {
            this.router.navigate([additionalData.page]);
        }
    }

    async redirectNotification(title: string, message: string, redirectRouter: string) {

        const alert = await this.alertController.create({
            header: title,
            message: message,
            buttons: [
                {
                    text: 'Não',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        console.log('Confirm Cancel: blah');
                        this.isAlreadyShowAlert = false;
                    }
                }, {
                    text: 'Sim',
                    handler: () => {
                        this.router.navigate([redirectRouter]);
                        this.isAlreadyShowAlert = false;

                    }
                }
            ]
        });

        await alert.present();

    }

}
